
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlog/skeleton/carousel_skeleton",
      function () {
        return require("private-next-pages/vlog/skeleton/carousel_skeleton.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlog/skeleton/carousel_skeleton"])
      });
    }
  